import localStore from 'store2';

const storageManager = (store) =>
{
    let storedState = localStore('kitakurs');
    if (storedState)
    {
        store.replaceState(storedState);
        storedState = null;
    }

    store.subscribe((mutation, state) =>
    {
        localStore('kitakurs', state);
    });
};

export default storageManager;
